/* hai-ficha.js — "Ver más" de la ficha (16-sep-2026, pedido de Andrés: la descripción y la nota
   "Importante" son los textos más largos; quedan en 4 y 3 líneas con un botón para abrirlos).

   Mejora progresiva: el markup declara data-hai-clamp="N" y aquí se aplica el recorte (clase
   .hai-clamp con --hai-clamp) SOLO si el texto de verdad sobra (scrollHeight > clientHeight);
   si cabe, no hay recorte ni botón. Sin JS el texto se ve completo. El botón es un <button>
   (no hereda fuente ni color: lo declara el CSS) que alterna "Ver más" / "Ver menos" y
   aria-expanded. Idempotente por marca en el propio nodo; se repite al cargar secciones en el
   editor. CSS: bloque "Ver más" de hai-ficha.css. */
(function () {
  'use strict';

  function preparar(el) {
    if (el.dataset.haiClampListo) return;
    el.dataset.haiClampListo = '1';
    var n = parseInt(el.dataset.haiClamp, 10) || 4;
    el.style.setProperty('--hai-clamp', String(n));
    el.classList.add('hai-clamp');
    if (el.scrollHeight <= el.clientHeight + 2) {
      el.classList.remove('hai-clamp');
      return;
    }
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'hai-clamp__btn';
    btn.textContent = 'Ver más';
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', function () {
      var abierto = el.classList.toggle('hai-clamp--abierto');
      btn.textContent = abierto ? 'Ver menos' : 'Ver más';
      btn.setAttribute('aria-expanded', abierto ? 'true' : 'false');
    });
    el.insertAdjacentElement('afterend', btn);
  }

  function todos() {
    document.querySelectorAll('[data-hai-clamp]').forEach(preparar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', todos);
  } else {
    todos();
  }
  document.addEventListener('shopify:section:load', todos);
})();
